import { formatTime } from 'kv-logger';
import { debounce } from 'lodash-es';
import { ReportLogs } from '../../../lib/report/service';
const toString = (val) => {
    switch (typeof val) {
        case 'string':
            return val;
        case 'number':
            return `${val}`;
        case 'boolean':
            return val ? '1' : '0';
        case 'object':
            return JSON.stringify(val);
        case 'bigint':
            return val.toString();
        default:
            return undefined;
    }
};
const stringifyFields = (params) => {
    return Object.keys(params).reduce((result, key) => {
        const stringVal = toString(params[key]);
        if (stringVal !== undefined) {
            // eslint-disable-next-line no-param-reassign
            result[key] = stringVal;
        }
        return result;
    }, {});
};
export class APILogTransport {
    constructor() {
        this.context = {};
        this.pendingLogs = [];
        this.debouncedReportLog = debounce(this.doReportLogs, 1000);
    }
    updateContext(params) {
        Object.assign(this.context, params);
    }
    write(log) {
        this.pendingLogs.push({
            fields: stringifyFields(Object.assign(Object.assign(Object.assign({}, this.context), log), { time: formatTime(log.time) })),
        });
        this.debouncedReportLog();
        // flush log if it's more than 20 records
        if (this.pendingLogs.length > 20) {
            this.debouncedReportLog.flush();
        }
    }
    doReportLogs() {
        if (this.pendingLogs.length === 0) {
            return;
        }
        ReportLogs({
            logs: this.pendingLogs,
        });
        this.pendingLogs.length = 0;
    }
}
